// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { type FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTransferOperationData } from '@shared/portfolio-operations/providers';
import { CurrentPositionDisplay } from '../current-position-display/current-position-display';
import { RefundOptions } from './refund-options';
import { DestinationFundsList } from '../destination-funds-list/destination-funds-list';
import { FundSearchInput } from '../fund-search-input/fund-search-input';

export const TransferOperationFormContent: FC = () => {
  const {
    sourceAsset,
    portfolioFunds,
    form,
    onAddDestinationFund,
    excludedTickers,
  } = useTransferOperationData();

  return (
    <FormProvider {...form}>
      <div className="space-y-3">
        <CurrentPositionDisplay
          investment={sourceAsset.investment}
          quantity={sourceAsset.quantity}
          currency={sourceAsset.currency}
        />

        <RefundOptions />

        <div className="space-y-3">
          <DestinationFundsList />

          <FundSearchInput
            onSelectFund={onAddDestinationFund}
            excludedTickers={excludedTickers}
            portfolioFunds={portfolioFunds}
          />
        </div>
      </div>
    </FormProvider>
  );
};
